/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component, PropsWithChildren } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import GroupUserElementView from './GroupUserElement.view';
import { AnyPerson } from '../../utils/AnyPerson';

interface Props {
	title?: string;
	admins: AnyPerson[];
	handleUserDeletion?: (user: AnyPerson) => void;
}

class GroupAdministratorsView extends Component<PropsWithChildren<Props>> {
	render(): JSX.Element {
		const { title, admins, children, handleUserDeletion } = this.props;
		return (
			<Box mb={4}>
				<Grid container>
					{title && (
						<Grid item xs={12}>
							<Typography variant="h2" gutterBottom>
								{title}
							</Typography>
						</Grid>
					)}
					<Grid item xs={12}>
						<Grid container spacing={3}>
							<Grid item xs={12} md={6} lg={3}>
								{children}
							</Grid>
						</Grid>
						<Grid container spacing={3}>
							{admins &&
								admins.map(admin => (
									<Grid key={admin.id} item>
										<GroupUserElementView
											user={admin}
											handleUserDeletion={
												handleUserDeletion
													? (): void => {
															handleUserDeletion(admin);
													  }
													: undefined
											}
										/>
									</Grid>
								))}
						</Grid>
					</Grid>
				</Grid>
			</Box>
		);
	}
}

export default GroupAdministratorsView;
